// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__EK-Qn","loaderBody":"Loader_loaderBody__Bgkc8"};